import { reactive } from 'vue';
import { messages } from './messages';
import { getStoredEmbedParam } from '../utils/embedParams';
import { normalizeH5Locale, detectLocaleFromNavigator, htmlLangAttr, isSupportedLocale } from './locale';

function detectLocale() {
  const q = new URLSearchParams(window.location.search).get('lang');
  if (q) return normalizeH5Locale(q);
  const stored = getStoredEmbedParam('lang');
  if (stored) return normalizeH5Locale(stored);
  return detectLocaleFromNavigator();
}

export const i18nState = reactive({
  locale: detectLocale()
});

function resolve(obj, path) {
  return path.split('.').reduce((o, k) => (o && o[k] != null ? o[k] : null), obj);
}

export function t(key, params = {}) {
  const pack = messages[i18nState.locale] || messages.en;
  let str = resolve(pack, key);
  if (str == null) {
    str = resolve(messages.en, key);
  }
  if (str == null) return key;
  if (typeof str !== 'string') return String(str);
  return str.replace(/\{(\w+)\}/g, (_, name) =>
    params[name] != null ? String(params[name]) : `{${name}}`
  );
}

export function setLocale(locale) {
  const next = normalizeH5Locale(locale);
  if (!isSupportedLocale(next)) return;
  i18nState.locale = next;
  document.documentElement.lang = htmlLangAttr(next);
}

export { normalizeH5Locale };

export const i18nPlugin = {
  install(app) {
    document.documentElement.lang = htmlLangAttr(i18nState.locale);
    app.config.globalProperties.$t = t;
    app.config.globalProperties.$locale = () => i18nState.locale;
    app.config.globalProperties.$setLocale = setLocale;
    app.provide('i18n', { state: i18nState, t, setLocale });
  }
};
